import DeductibleReductionStep from "components/steps/DeductibleReductionStep";

const Step13Page = () => <DeductibleReductionStep />;

export default Step13Page;
